import { useEffect, useState } from "react";

export default function useScrollSpy(ids = [], rootMargin = "-40% 0px -55% 0px") {
  const [activeId, setActiveId] = useState("");
  useEffect(() => {
    if (!ids.length) return;
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setActiveId(e.target.id)),
      { rootMargin }
    );
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) obs.observe(el);
    });
    return () => obs.disconnect();
  }, [ids, rootMargin]);
  return activeId;
}
